import SizeSelector from '@phoenix/components/SizeSelector';
import Bag from '@phoenix/components/Bag';
import Product from '@phoenix/components/Product';
import FindInBoutique from '@phoenix/components/FindInBoutique';

Object.assign(window, {
  Bag,
  SizeSelector,
  Product,
  FindInBoutique,
});
